module.exports = __webpack_public_path__ + "img/p2-54.32950c18.png";